import React from 'react';
import cn from 'classnames';

import styles from './QrCode.module.scss';

const QrCode = ({
  className = '',
  imgSrc = '',
  text = 'Scan this code in the nuviu browser when you’re ready',
}) => {
  return (
    <div className={cn(styles.qrCode, className)}>
      <img src={imgSrc} alt="qr code" />
      <p className={styles.qrCodeDesc}>{text}</p>
    </div>
  );
};

export default QrCode;
